import { makeAutoObservable } from 'mobx'
import { openApi } from '../../../helpers/request'
import { notification } from 'antd'
import i from '../../../translations/i'
import __multiple from '../../../helpers/multiple_actions/__multiple'

interface FormInterface {
    label: string
    target_type: 'all' | 'category'
    target_category_ids: number[]
    block_source: 'category' | 'list'
    custom_list_id: number | null
}

class BulkRelatedController {

    tree: any[] = []
    lists: any[] = []
    jobs: any[] = []

    loading: boolean = false

    form: FormInterface = {
        label: '',
        target_type: 'all',
        target_category_ids: [],
        block_source: 'category',
        custom_list_id: null,
    }

    private pollTimer: ReturnType<typeof setInterval> | null = null

    constructor() {
        makeAutoObservable(this)
    }

    getCategoryTree() {
        openApi('get', '/category/tree')
            .then(result => { this.tree = result.data })
            .catch(error => console.log(error.response))
    }

    getLists() {
        openApi('get', '/custom_list_products')
            .then(result => { this.lists = result.data })
            .catch(error => console.log(error.response))
    }

    getJobs() {
        openApi('get', '/bulk_related_products')
            .then(result => {
                this.jobs = result.data

                const hasActive = this.jobs.some((job: any) => job.status === 'pending' || job.status === 'processing')
                if (!hasActive) this.stopPolling()
            })
            .catch(error => console.log(error.response))
    }

    // Пока есть незавершённые джобы — опрашиваем список раз в 3 сек, чтобы видеть прогресс.
    startPolling() {
        this.getJobs()

        if (this.pollTimer) return

        this.pollTimer = setInterval(() => this.getJobs(), 3000)
    }

    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer)
            this.pollTimer = null
        }
    }

    setForm(name: string, value: any) {
        // @ts-ignore
        this.form[name] = value
    }

    start() {
        if (!this.form.label) {
            notification.error({
                message: i.t('def:errors.error'),
                description: i.t('relatedBulk:labelRequired')
            })
            return
        }

        if (this.form.target_type === 'category' && this.form.target_category_ids.length === 0) {
            notification.error({
                message: i.t('def:errors.error'),
                description: i.t('relatedBulk:categoryRequired')
            })
            return
        }

        if (this.form.block_source === 'list' && !this.form.custom_list_id) {
            notification.error({
                message: i.t('def:errors.error'),
                description: i.t('relatedBulk:listRequired')
            })
            return
        }

        this.loading = true

        const data = new FormData()
        data.append('label', this.form.label)
        data.append('target_type', this.form.target_type)
        if (this.form.target_type === 'category') {
            this.form.target_category_ids.map(id => data.append('target_category_id[]', `${id}`))
        }
        data.append('block_source', this.form.block_source)
        if (this.form.block_source === 'list' && this.form.custom_list_id) {
            data.append('custom_list_id', `${this.form.custom_list_id}`)
        }

        openApi('post', '/bulk_related_products', data)
            .then(() => {
                notification.success({
                    message: i.t('def:success.success'),
                    description: i.t('relatedBulk:started')
                })

                this.form = {
                    label: '',
                    target_type: 'all',
                    target_category_ids: [],
                    block_source: 'category',
                    custom_list_id: null,
                }

                this.startPolling()
            })
            .catch(error => {
                notification.error({
                    message: i.t('def:errors.error'),
                    description: error.response?.data?.data?.message ?? ''
                })
            })
            .finally(() => { this.loading = false })
    }

    actions() {
        return [
            { label: i.t('def:delete_elements'), value: 'delete', action: () => this.deleteSelected() },
        ]
    }

    deleteSelected() {
        const data = new FormData()
        __multiple.selected.map(id => data.append('elements[]', `${id}`))

        openApi('post', '/bulk_related_products/delete', data)
            .then(() => {
                __multiple.clear()
                this.getJobs()
            })
            .catch(error => {
                notification.error({
                    message: i.t('def:errors.error'),
                    description: error.response?.data?.data?.message ?? ''
                })
            })
    }
}

export default new BulkRelatedController()
